webpackJsonp([35],{

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("aac5b4b8", content, true, {});

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.page-dealers-projects[data-v-ae2ffaa8]{padding:80px 50px 0}.switch-assign[data-v-ae2ffaa8]{width:120px}.company-disabled[data-v-ae2ffaa8]{opacity:.4}", "", {"version":3,"sources":["/opt/build/repo/src/pages/configuration/page-dealers-projects.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,wCAAwC,mBAAmB,CAC1D,AACD,gCAAgC,WAAW,CAC1C,AACD,mCAAmC,UAAU,CAC5C","file":"page-dealers-projects.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.page-dealers-projects[data-v-ae2ffaa8]{padding:80px 50px 0\n}\n.switch-assign[data-v-ae2ffaa8]{width:120px\n}\n.company-disabled[data-v-ae2ffaa8]{opacity:.4\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dealers-projects"},[_c('app-table',{staticClass:"mt-3 is-not-selectable",attrs:{"name":"implementers","columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.projectCode)+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"switch-assign"},[_c('div',{on:{"click":function($event){return _vm.openModal(props.row)}}},[_c('v-switch',{staticClass:"mt-0",attrs:{"color":"info","hide-details":"","label":_vm.labelState(props.row.flagAssigned)},model:{value:(props.row.flagAssigned),callback:function ($$v) {_vm.$set(props.row, "flagAssigned", $$v)},expression:"props.row.flagAssigned"}})],1)]),_vm._v(" "),_c('td',[(props.row.flagCompanyParent)?_c('app-tooltip-button',{class:{ 'company-disabled': !props.row.flagAssigned },attrs:{"disabled":!props.row.flagAssigned,"color":"primary","icon":"location_city","text":"Compañías maestras"},on:{"click-icon":function($event){return _vm.masterCompanies(props.row)}}}):_vm._e()],1)]}}])}),_vm._v(" "),_c('app-confirmation-modal',{attrs:{"confirmation-text":"Aceptar","show-modal":_vm.modalConfirmation.value,"text":_vm.modalContent},on:{"cancel":_vm.cancelModal,"confirm":_vm.confirm}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_projects_vue__ = __webpack_require__(847);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae2ffaa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_projects_vue__ = __webpack_require__(1074);
function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae2ffaa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae2ffaa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		buttonColor: buttonColor,
		isEditAction: isEditAction,
		isListAll: isListAll
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'green'
		},
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01775c3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("673c19a2", content, true, {});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-icon-button[data-v-01775c3c]{background:#f2f6f9!important;border:1px solid transparent;border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px}.action-icon-button .icon[data-v-01775c3c]{font-size:17px}.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef!important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa!important;border-color:#bed8ea}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-tooltip-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,6BAA8B,6BAA+B,kBAAkB,YAAY,eAAe,2FAA2F,mFAAmF,2EAA2E,uGAAuG,UAAU,CACxf,AACD,2CAA2C,cAAc,CACxD,AACD,2CAA2C,6BAA8B,qBAAqB,mCAAmC,0BAA0B,CAC1J,AACD,0DAA0D,6BAA8B,oBAAoB,CAC3G","file":"app-tooltip-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-icon-button[data-v-01775c3c]{background:#f2f6f9 !important;border:1px solid rgba(0,0,0,0);border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px\n}\n.action-icon-button .icon[data-v-01775c3c]{font-size:17px\n}\n.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef !important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa !important;border-color:#bed8ea\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"action-icon-button ma-0",class:{ 'is-edit-action': _vm.isEditAction },attrs:{"slot":"activator","flat":"","icon":"","aria-label":_vm.text,"small":"","color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[_c('v-icon',{style:(_vm.isListAll)},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TONES = {
	danger: { accent: '#d64545', icon: 'delete_outline', tint: '#fdecec' },
	info: { accent: '#176fc1', icon: 'help_outline', tint: '#eaf2fb' },
	warning: { accent: '#c8871a', icon: 'warning', tint: '#fdf1dc' }
};

function tokens() {
	return TONES[this.tone] || TONES.danger;
}

function icon() {
	return this.iconName || this.tokens.icon;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-confirmation-modal',
	computed: {
		icon: icon,
		tokens: tokens
	},
	props: {
		cancelText: {
			type: String,
			default: 'Cancelar'
		},
		confirmationText: {
			type: String,
			default: 'Eliminar'
		},
		eyebrow: {
			type: String,
			default: 'CONFIRMACIÓN REQUERIDA'
		},
		hint: {
			type: String,
			default: ''
		},
		iconName: {
			type: String,
			default: ''
		},
		loading: {
			default: false,
			type: Boolean
		},
		loadingText: {
			type: String,
			default: 'Procesando…'
		},
		showModal: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: 'Está seguro que desea eliminar este registro?'
		},
		title: {
			type: String,
			default: 'Confirma la acción'
		},
		tone: {
			type: String,
			default: 'danger'
		},
		width: {
			type: Number,
			default: 460
		}
	}
});

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582bde4d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(597)
  __webpack_require__(599)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-582bde4d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582bde4d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("65495f4c", content, true, {});

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.app-confirm-dialog{border-radius:16px!important;-webkit-box-shadow:0 24px 60px rgba(19,38,57,.28)!important;box-shadow:0 24px 60px rgba(19,38,57,.28)!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-confirmation-modal.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,oBAAoB,6BAA8B,4DAA6D,mDAAoD,CAClK","file":"app-confirmation-modal.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.app-confirm-dialog{border-radius:16px !important;-webkit-box-shadow:0 24px 60px rgba(19,38,57,.28) !important;box-shadow:0 24px 60px rgba(19,38,57,.28) !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(600);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("7f74b8f0", content, true, {});

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.app-confirm-card[data-v-582bde4d]{border-radius:16px!important;-webkit-box-shadow:none!important;box-shadow:none!important;overflow:hidden;padding:0}.app-confirm-body[data-v-582bde4d]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:14px;padding:22px 22px 18px}.app-confirm-icon[data-v-582bde4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:13px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:46px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:46px}.app-confirm-icon .icon[data-v-582bde4d]{color:inherit;font-size:23px}.app-confirm-copy[data-v-582bde4d]{min-width:0}.app-confirm-copy small[data-v-582bde4d]{color:#8497a8;display:block;font-size:9px;font-weight:700;letter-spacing:.12em}.app-confirm-copy h3[data-v-582bde4d]{color:#263f56;font-family:Opens_semibold;font-size:16px;font-weight:600;line-height:1.3;margin:2px 0 0}.app-confirm-copy p[data-v-582bde4d]{color:#6b7c8d;font-size:13px;line-height:1.45;margin:6px 0 0}.app-confirm-hint[data-v-582bde4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8495a5;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;gap:5px;margin-top:9px}.app-confirm-hint .icon[data-v-582bde4d]{color:#b4bfca;font-size:14px}.app-confirm-actions[data-v-582bde4d]{background:#f7f9fc;border-top:1px solid #e9eff5;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:14px 22px}.app-confirm-btn[data-v-582bde4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid transparent;border-radius:9px;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:12px;font-weight:700;height:38px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:.02em;min-width:108px;outline:none;padding:0 16px;-webkit-transition:background .15s ease,-webkit-box-shadow .15s ease;transition:background .15s ease,-webkit-box-shadow .15s ease;transition:background .15s ease,box-shadow .15s ease;transition:background .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease}.app-confirm-btn[data-v-582bde4d]:disabled{cursor:default;opacity:.65}.app-confirm-btn-ghost[data-v-582bde4d]{background:#fff;border-color:#d4dee7;color:#53697d}.app-confirm-btn-ghost[data-v-582bde4d]:hover:not(:disabled){background:#f1f5f9}.app-confirm-btn-solid[data-v-582bde4d]{background:#d64545;color:#fff}.app-confirm-btn-solid[data-v-582bde4d]:hover:not(:disabled){-webkit-filter:brightness(.93);filter:brightness(.93)}@media(max-width:560px){.app-confirm-body[data-v-582bde4d]{padding:18px 16px 14px}.app-confirm-actions[data-v-582bde4d]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;padding:13px 16px}.app-confirm-btn[data-v-582bde4d]{width:100%}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-confirmation-modal.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,mCAAmC,6BAA8B,kCAAmC,0BAA2B,gBAAgB,SAAS,CACvJ,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,SAAS,sBAAsB,CACtH,AACD,mCAAmC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACzT,AACD,yCAAyC,cAAc,cAAc,CACpE,AACD,mCAAmC,WAAW,CAC7C,AACD,yCAAyC,cAAc,cAAc,cAAc,gBAAgB,oBAAoB,CACtH,AACD,sCAAsC,cAAc,2BAA6B,eAAe,gBAAgB,gBAAgB,cAAc,CAC7I,AACD,qCAAqC,cAAc,eAAe,iBAAiB,cAAc,CAChG,AACD,mCAAmC,yBAAyB,sBAAsB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,eAAe,QAAQ,cAAc,CAC5M,AACD,yCAAyC,cAAc,cAAc,CACpE,AACD,sCAAsC,mBAAmB,6BAA6B,oBAAoB,oBAAoB,aAAa,QAAQ,qBAAqB,kBAAkB,yBAAyB,iBAAiB,CACnO,AACD,kCAAkC,yBAAyB,sBAAsB,mBAAmB,6BAA+B,kBAAkB,eAAe,2BAA2B,2BAA2B,oBAAoB,eAAe,gBAAgB,YAAY,wBAAwB,qBAAqB,uBAAuB,qBAAqB,gBAAgB,aAAa,eAAe,qEAAqE,6DAA6D,qDAAqD,iFAAiF,CACrqB,AACD,2CAA2C,eAAe,WAAW,CACpE,AACD,wCAAwC,gBAAgB,qBAAqB,aAAa,CACzF,AACD,6DAA6D,kBAAkB,CAC9E,AACD,wCAAwC,mBAAmB,UAAU,CACpE,AACD,6DAA6D,+BAAgC,sBAAuB,CACnH,AACD,wBACA,mCAAmC,sBAAsB,CACxD,AACD,sCAAsC,4BAA4B,8BAA8B,kCAAkC,8BAA8B,iBAAiB,CAChL,AACD,kCAAkC,UAAU,CAC3C,CACA","file":"app-confirmation-modal.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.app-confirm-card[data-v-582bde4d]{border-radius:16px !important;-webkit-box-shadow:none !important;box-shadow:none !important;overflow:hidden;padding:0\n}\n.app-confirm-body[data-v-582bde4d]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:14px;padding:22px 22px 18px\n}\n.app-confirm-icon[data-v-582bde4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:13px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:46px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:46px\n}\n.app-confirm-icon .icon[data-v-582bde4d]{color:inherit;font-size:23px\n}\n.app-confirm-copy[data-v-582bde4d]{min-width:0\n}\n.app-confirm-copy small[data-v-582bde4d]{color:#8497a8;display:block;font-size:9px;font-weight:700;letter-spacing:.12em\n}\n.app-confirm-copy h3[data-v-582bde4d]{color:#263f56;font-family:\"Opens_semibold\";font-size:16px;font-weight:600;line-height:1.3;margin:2px 0 0\n}\n.app-confirm-copy p[data-v-582bde4d]{color:#6b7c8d;font-size:13px;line-height:1.45;margin:6px 0 0\n}\n.app-confirm-hint[data-v-582bde4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8495a5;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;gap:5px;margin-top:9px\n}\n.app-confirm-hint .icon[data-v-582bde4d]{color:#b4bfca;font-size:14px\n}\n.app-confirm-actions[data-v-582bde4d]{background:#f7f9fc;border-top:1px solid #e9eff5;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:14px 22px\n}\n.app-confirm-btn[data-v-582bde4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid rgba(0,0,0,0);border-radius:9px;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:12px;font-weight:700;height:38px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:.02em;min-width:108px;outline:none;padding:0 16px;-webkit-transition:background .15s ease,-webkit-box-shadow .15s ease;transition:background .15s ease,-webkit-box-shadow .15s ease;transition:background .15s ease,box-shadow .15s ease;transition:background .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease\n}\n.app-confirm-btn[data-v-582bde4d]:disabled{cursor:default;opacity:.65\n}\n.app-confirm-btn-ghost[data-v-582bde4d]{background:#fff;border-color:#d4dee7;color:#53697d\n}\n.app-confirm-btn-ghost[data-v-582bde4d]:hover:not(:disabled){background:#f1f5f9\n}\n.app-confirm-btn-solid[data-v-582bde4d]{background:#d64545;color:#fff\n}\n.app-confirm-btn-solid[data-v-582bde4d]:hover:not(:disabled){-webkit-filter:brightness(0.93);filter:brightness(0.93)\n}\n@media(max-width: 560px){\n.app-confirm-body[data-v-582bde4d]{padding:18px 16px 14px\n}\n.app-confirm-actions[data-v-582bde4d]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;padding:13px 16px\n}\n.app-confirm-btn[data-v-582bde4d]{width:100%\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"content-class":"app-confirm-dialog","persistent":"","value":_vm.showModal,"width":_vm.width}},[_c('v-card',{staticClass:"app-confirm-card"},[_c('div',{staticClass:"app-confirm-body"},[_c('span',{staticClass:"app-confirm-icon",style:({ backgroundColor: _vm.tokens.tint, color: _vm.tokens.accent })},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('div',{staticClass:"app-confirm-copy"},[_c('small',[_vm._v(_vm._s(_vm.eyebrow))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.hint)?_c('span',{staticClass:"app-confirm-hint"},[_c('v-icon',[_vm._v("info_outline")]),_vm._v(_vm._s(_vm.hint)+"\n\t\t\t\t")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"app-confirm-actions"},[_c('button',{staticClass:"app-confirm-btn app-confirm-btn-ghost",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.cancelText)+"\n\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"app-confirm-btn app-confirm-btn-solid",style:({ backgroundColor: _vm.tokens.accent }),attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('confirm')}}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"mr-2",attrs:{"indeterminate":"","size":"14","width":"2"}}):_vm._e(),_vm._v("\n\t\t\t\t"+_vm._s(_vm.loading ? _vm.loadingText : _vm.confirmationText)+"\n\t\t\t")],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_confirmation_modal__ = __webpack_require__(596);



var projectList = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 20,
							isSelected: 2
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get('distributaries/' + this.id + '/projects', { params: params });

					case 4:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function projectList() {
		return _ref.apply(this, arguments);
	};
}();

var deallocateButton = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(project) {
		var projectIds, body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						projectIds = [project.id];
						body = { projectIds: projectIds };
						_context2.prev = 2;
						_context2.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/projects', { data: body });

					case 5:
						this.showNotification('El proyecto fue desasignado correctamente');
						_context2.next = 12;
						break;

					case 8:
						_context2.prev = 8;
						_context2.t0 = _context2['catch'](2);

						this.$set(project, 'flagAssigned', !project.flagAssigned);
						this.showError();

					case 12:
						this.cancelModalConfirmation();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 8]]);
	}));

	return function deallocateButton(_x) {
		return _ref2.apply(this, arguments);
	};
}();

var assignRow = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(project) {
		var projectIds, body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						projectIds = [project.id];
						body = { projectIds: projectIds };
						_context3.prev = 2;
						_context3.next = 5;
						return this.$http.post('distributaries/' + Number(this.id) + '/projects', body);

					case 5:
						this.showNotification('El proyecto fue asignado correctamente');
						_context3.next = 12;
						break;

					case 8:
						_context3.prev = 8;
						_context3.t0 = _context3['catch'](2);

						this.$set(project, 'flagAssigned', !project.flagAssigned);
						this.showError();

					case 12:
						this.cancelModalConfirmation();

					case 13:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[2, 8]]);
	}));

	return function assignRow(_x2) {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.projectList();
}

function assignmentDist(project) {
	var options = {
		1: this.assignRow,
		0: this.deallocateButton
	};
	options[Number(project.flagAssigned)].call(this, project);
}

function beforeRouteLeave(to, from, next) {
	var pathTo = to.path;
	var pathFrom = from.path;
	if (pathTo === pathFrom && to.name !== from.name) {
		next({ name: 'page-configuration' });
	} else {
		next();
	}
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
}

function labelState(assigned) {
	return assigned ? 'Asignado' : '';
}

function masterCompanies(project) {
	var codeProject = project.codeProject;

	this.$router.push({ name: 'assignment-master-companies', params: { codeProject: codeProject } });
}

function confirm() {
	this.assignmentDist(this.currentProject);
}

function modalContent() {
	var project = this.currentProject && this.currentProject.name;
	var distributer = this.$route.params.name;
	return '\xBFDesea asignar el proyecto ' + project + ' al distribuidor ' + distributer + '?';
}

function cancelModal() {
	var flagAssigned = this.currentProject.flagAssigned;

	this.currentProject.flagAssigned = !flagAssigned;
	this.cancelModalConfirmation();
}

function openModal(project) {
	this.currentProject = project;
	this.openModalConfirmation();
}

function data() {
	return {
		columns: [{ id: 1, name: 'Nombre', visible: true }, { id: 2, name: 'Descripción', visible: true }, { id: 3, name: 'Código del proyecto', visible: true }, { id: 4, name: 'Asignar', visible: true }, { id: 5, name: 'Acciones', visible: true }],
		currentPage: 1,
		currentProject: null,
		lastPage: 0,
		params: {
			page: 1,
			search: null
		},
		rows: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-dealers-projects',
	beforeRouteLeave: beforeRouteLeave,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */],
		appConfirmationModal: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_confirmation_modal__["a" /* default */]
	},
	computed: {
		modalContent: modalContent
	},
	created: created,
	data: data,
	methods: {
		assignmentDist: assignmentDist,
		assignRow: assignRow,
		cancelModal: cancelModal,
		changePage: changePage,
		confirm: confirm,
		deallocateButton: deallocateButton,
		labelState: labelState,
		masterCompanies: masterCompanies,
		onSearch: onSearch,
		openModal: openModal,
		projectList: projectList
	},
	props: {
		id: {
			type: [Number, String]
		},
		name: {
			type: String,
			required: true
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/35.da82042d387b97a347db.js